export default __webpack_public_path__ + "static/media/pano.9b79ca69.jpeg";